<mp-filter-group
  [filterName]="filterName()"
  [icon]="icon()"
  [searchable]="searchable()"
  [searchFieldPlaceholder]="searchFieldPlaceholder()"
  [(isExpanded)]="isExpanded"
  (searchTermChange)="searchTerm.set($event)"
>
  @if (showSelectionInfo() && selectionCount() > 0) {
    <mp-filter-badge filter-group-selection-info [value]="selectionCount()" />
  }

  @if (selectionCount() > 0) {
    <mp-filter-clear-button filter-group-clear-filter-action (clearFilter)="clearSelection()" />
  }

  <mp-multi-selection-filter
    [options]="visibleOptions()"
    [selectedValues]="selectedValues()"
    (selectedValuesChange)="onSelectionChanged($event)"
    (optionSelect)="onOptionSelected($event)"
  />

  @if (maxVisibleItems(); as maxVisibleItems) {
    <mp-show-all-options-button
      [(showAll)]="showAll"
      [totalItemsCount]="filteredOptions().length"
      [maxVisibleItemsCount]="maxVisibleItems"
    />
  }
</mp-filter-group>
